import styled, { css } from 'styled-components'

interface NewsletterMessageProps {
  success?: boolean
}

interface NewsletterButtonProps {
  $loading?: boolean
}

export const NewsletterContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

export const NewsletterTitle = styled.div`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  margin-bottom: 15px;
  font-weight: bold;
`

export const NewsletterForm = styled.form`
  display: flex;
  flex-direction: row;

  @media (max-width: 43.75rem) {
    flex-direction: column;
  }
`

export const NewsletterInput = styled.input`
  flex: 1;
  height: 40px;
  padding: 0 15px;
  border: none;
  border-radius: 4px 0 0 4px;
  background-color: ${({ theme }) => theme.palette.primary.contrastText};
  color: ${({ theme }) => theme.palette.primary.main};

  &:focus {
    outline: none;
  }

  @media (max-width: 43.75rem) {
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
  }
`

export const NewsletterButton = styled.button<NewsletterButtonProps>`
  height: 40px;
  padding: 0 20px;
  border: none;

  border-radius: 0 4px 4px 0;
  background-color: ${({ theme }) => theme.palette.primary.light};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;

  @media (max-width: 43.75rem) {
    border-radius: 4px;
    width: 100%;
  }

  ${({ $loading }) =>
    $loading &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.5;
    `}
`

export const NewsletterMessage = styled.p<NewsletterMessageProps>`
  margin-top: 10px;
  font-size: 14px;
  color: ${({ success, theme }) => (success ? theme.palette.success?.main : theme.palette.error?.main)};
`
